export default "__VITE_ASSET__c3WGa5Fz__"